import useListDoctorsLogic from "./useListDoctorsLogic";

export default useListDoctorsLogic;